<template>
  <div v-loading="isLoading">
    <div v-if="!selectedProject" class="content">
      <h5>No Project</h5>
    </div>
    <ul v-else>
      <li v-for="(value, key) in selectedProject" :key="key">
        <div v-if="keyToShow.includes(key) && value" class="contact-section">
          <div class="section-title">
            <span class="has-text-weight-bold">{{ getKeyTxt(key) }}</span>
          </div>
          <div class="section-content">
            <p>{{ value }}</p>
          </div>
        </div>
      </li>
      <li v-if="selectedProject.start_date">
        <div class="contact-section">
          <div class="section-title">
            <span class="has-text-weight-bold">{{ $t(`project.start_date`) }}</span>
          </div>
          <div class="section-content">
            <p>{{ $moment(selectedProject.start_date).format('YYYY/MM/DD') }}</p>
          </div>
        </div>
      </li>
      <li v-if="kmrtRole"> 
        <div class="file-list">
          <h2>
            文件
            <el-upload
              ref="upload"
              :http-request="uploadFile"
              :on-success="uploadSuccess"
              :file-list="fileList"
              action=""
              multiple
              name="file"
              accept=".doc,.docx,.xls,.xlsx,.pdf"
              :show-file-list="false"
            >
              <button class="btn-add">(新增)</button>
              <div slot="tip" class="el-upload__tip">
                <!-- 只能上傳docx/xlsx/pdf文件 -->
              </div>
            </el-upload>
          </h2>
          <table class="file-table">
            <thead>
              <tr>
                <th>編號</th>
                <th>文件名稱</th>
                <th>上傳日期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(file, i) in fileList" :key="file.uid">
                <td>{{ i + 1 }}</td>
                <td>
                  <a :href="file.url" target="_blank">{{ file.name }}</a>
                </td>
                <td>{{ formatDate(file.uploadTime) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
import { clientVersion } from '../constants/env';
export default {
  data() {
    return {
      isLoading: false,
      keyToShow: ['client', 'contractor', 'instrument_company', 'location', 'name', 'project_id'],
      fileList: [],
      baseUrl: '',
    };
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    kmrtRole() {
      return clientVersion === 'test' || clientVersion === 'kmrt';
    },
  },
  async mounted(){
    if(!this.kmrtRole) return;
    this.baseUrl = process.env.VUE_APP_IMAGE_BASE_URL;
    this.getFiles();
  },
  methods: {
    uploadFile(param) {
      this.isisUpdating = true;
      const file = param.file;
      const formData = new FormData();
      formData.append('file', file);

      this.$axios({
        method: 'post',
        apiName: `/project/${this.selectedProject._id}/file`,
        data: formData,
      })
        .then(res => {
          param.onSuccess(res, file);
        })
        .catch(error => {
          param.onError(error);
        });
    },
    async getFiles(){
      const res = await this.$axios({
        method: 'get',
        apiName: `/project/${this.selectedProject._id}/getfile`,
      });
      this.fileList = res.data.files.map((fileinfo, idx) => ({
        uid:        `f${idx}`,                                          // 唯一 key
        name:       fileinfo.filename,                                  // 顯示檔名
        status:     'success',                                          // 上傳狀態：success / uploading / error
        url:        `${this.baseUrl}/file/${fileinfo.filename}`, // 下載連結
        uploadTime: fileinfo.uploadTime,                                // 上傳時間
        response:   { filename: fileinfo.filename },                    // (選填) 若你要在 remove/delete 時用到
      }));
      console.log(this.fileList);
    },
    async uploadSuccess() {
      this.$notifySuccess('文件上傳成功');
      await this.$refs.upload.clearFiles();
      await this.getFiles();
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      const hh = String(date.getHours()).padStart(2, '0');
      const mm = String(date.getMinutes()).padStart(2, '0');
      return `${y}/${m}/${d} ${hh}:${mm}`;
    },
    getKeyTxt(key) {
      if(key === 'contractor' && this.kmrtRole) return this.$t('project.contractor_KMRT');
      return this.$t(`project.${key}`);
    },
  },
};
</script>

<style lang="stylus" scoped>
.rotate-quarter
  transform rotate(0.25turn)
.seperator
  margin 0 0.5rem
.contact-section
  .section-title
    .section-icon
      margin-right 1rem
  .section-content
    padding 1rem 2rem 2rem
</style>

<style scoped>
.file-list {
  padding: 20px;
}
.file-list h2 {
  display: flex;
  align-items: center;
  font-size: 20px;
}
.btn-add {
  margin-left: 10px;
  background: none;
  border: none;
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
}
.btn-add:hover {
  text-decoration: underline;
}
.file-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
.file-table th,
.file-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}
</style>
